// This file Initializes some Vue apps within server-rendered pages in the iframe.
//
// This file is only needed temporarily while import maps are still being used on Django pages;
// it can be deleted after the ssr iframe within DefaultLayout.vue is fully in-use for Django
// pages and after it is no longer being imported in the Django templates.

import Button from '@leaflink/stash/Button.vue';
import PageNavigation from '@leaflink/stash/PageNavigation.vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createApp } from 'vue';

// Vue components leveraged on both Vue and Django-powered pages.
import LLBanner from '@/components/LLBanner';
import LLImage from '@/components/LLImage/LLImage.vue';
import AddStrainModal from '@/pages/Inventory/components/Strains/AddStrainModal.vue';
import { addBasePlugins } from '@/plugins';
import { loadTranslations } from '@/plugins/i18n';
import { createRouter } from '@/router';

import tanStackQueryClient from './queries/tanStackQueryClient';
import { decodeSegmentTrackPageDataFromQueryParams } from './utils/segmentTrackPageData';

function addPlugins(app) {
  addBasePlugins(app);
  app.use(createRouter);
  app.use(VueQueryPlugin, { queryClient: tanStackQueryClient });
}

// This utility function is necessary to be globally available for Django-powered pages in order to decode segment events page data
if (!window['decodeSegmentTrackPageDataFromQueryParams']) {
  window['decodeSegmentTrackPageDataFromQueryParams'] = decodeSegmentTrackPageDataFromQueryParams;
}

// Mounted in navigation-tabs-new.html > only exists on Inventory vertical
const $pageNav = document.querySelector('#ll-page-navigation');
// Mounted in banner.html > base_new.html and base_svelte.html
const $banner = document.querySelector('#banner-app');
// Mounted in product-details.html > this could be scoped to this specific template instead of globally registered
const $llImages = document.querySelectorAll('.ll-image-app');

// ------- banners ------
if ($banner) {
  // eslint-disable-next-line vue/one-component-per-file
  const bannerApp = createApp({
    components: {
      'll-banner': LLBanner,
    },
    computed: {
      banners() {
        return window._activeBanners;
      },
    },
  });

  bannerApp.config.compilerOptions.delimiters = ['[[', ']]'];

  addPlugins(bannerApp);
  bannerApp.mount($banner);
}

// ------ LLImages ------
$llImages?.forEach(($el) => {
  // eslint-disable-next-line vue/one-component-per-file
  const app = createApp({
    components: {
      'll-image': LLImage,
    },
  });

  addPlugins(app);
  app.mount($el.parentNode);
});

// ------ Page Navigation ------
if ($pageNav) {
  // eslint-disable-next-line vue/one-component-per-file
  const pageNavApp = createApp({});

  addPlugins(pageNavApp);
  pageNavApp.component('ll-page-navigation', PageNavigation);

  pageNavApp.mount($pageNav);
}

// ------ Inventory ------

// TODO: remove this global registration when https://leaflink.atlassian.net/browse/CE-331 (Product Edit/Create Page Redesign) is complete
// Mounted in manage-products-add.html >  this could be scoped to this specific template instead of globally registered
const $addStrainApp = document.querySelector('#add-strain-app');

if ($addStrainApp && !$addStrainApp?.__vue_app__) {
  // eslint-disable-next-line vue/one-component-per-file
  const addStrainApp = createApp({
    components: {
      'll-button': Button,
      'add-strain-modal': AddStrainModal,
    },
    async created() {
      await loadTranslations('inventory');
    },
  });

  addPlugins(addStrainApp);

  window['ll-legacy'] = {
    ...(window['ll-legacy'] || {}),
    __addStrainApp: addStrainApp,
  };
}
